<template>
  <div
    id="tooltip"
    v-bind:style="positionObject"
    class="tooltip mds-tooltip mds-tooltip--default mds-tooltip--sticky"
    :class="[sizeClass, orientationClass]"
    role="tooltip"
    aria-hidden="false"
    aria-labelledby="statustooltip"
  >
    <div class="mds-tooltip__text tooltip-text" id="tooltiptext">
      <ul>
        <li v-for="(item, index) in content" :key="index">
          {{ item }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'toolTip',
  props: {
    positionX: {
      default: 0,
      type: Number,
    },
    positionY: {
      default: 0,
      type: Number,
    },
    content: {
      default: [''],
      type: Array,
    },
    size: {
      default: 'l',
      type: String,
    },
    orientation: {
      default: 'bottom-right',
      type: String,
    },
  },
  computed: {
    positionObject() {
      return {
        left: `${this.positionX}px`,
        top: `${this.positionY}px`,
      };
    },
    orientationClass() {
      return `mds-tooltip--${this.orientation}`;
    },
    sizeClass() {
      return `mds-tooltip--width-${this.size}`;
    },
  },
};
</script>
<style lang="scss">
.tooltip {
  position: absolute;
  z-index: 9999;
  min-height: 30px;
  display: table;
  ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }
}
</style>
